import type { SpaceGroup } from "@circle-react/types/SpaceGroup";
import { useMemo } from "react";

import { getColumns } from "../columns";
import { useSpaceGroupMembersTabActions } from "./useSpaceGroupMembersTabActions";
import { useSpaceGroupMembersTabData } from "./useSpaceGroupMembersTabData";
import { useSpaceGroupMembersTabRowActions } from "./useSpaceGroupMembersTabRowActions";

export const useSpaceGroupMembersTab = (spaceGroup: SpaceGroup) => {
  const { infiniteQuery, query, setQuery } =
    useSpaceGroupMembersTabData(spaceGroup);
  const {
    addMemberButtonLabel,
    handleChangeMemberRole,
    handleEditMember,
    handleOpenAddMemberModal,
    handleOpenRemoveConfirmation,
    isAdmin,
  } = useSpaceGroupMembersTabActions({
    queryKey: infiniteQuery.queryKey,
    spaceGroupId: spaceGroup.id,
  });

  const columns = useMemo(
    () =>
      getColumns({
        onRoleChange: handleChangeMemberRole,
        spaceGroupId: spaceGroup.id,
      }),
    [handleChangeMemberRole, spaceGroup.id],
  );

  const rowActions = useSpaceGroupMembersTabRowActions({
    isAdmin,
    onEditMember: handleEditMember,
    onRemoveMember: handleOpenRemoveConfirmation,
  });

  return {
    addMemberButtonLabel,
    columns,
    handleOpenAddMemberModal,
    infiniteQuery,
    isAdmin,
    query,
    rowActions,
    setQuery,
  };
};
